
import { React, useEffect, useState } from "react";
import Helper from "../../utility/helper";
import ApiHelper from '../../utility/ApiHelper';
import { Box, Card, CardContent } from "@mui/material";
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import ClearSunny from '../../assets/weather/clearsunny.svg';
import Rain from '../../assets/weather/RAIN.svg';
import Thunderstorm from '../../assets/weather/thunderstorm.svg';
import Clouds from '../../assets/weather/CLOUDS.svg';
import Drizzle from '../../assets/weather/DRIZZLE.svg';
import Fog from '../../assets/weather/fog.svg';
import Haze from '../../assets/weather/haze.svg';
import Mist from '../../assets/weather/mist.svg';
import Smoke from '../../assets/weather/smoke.svg';
import Snow from '../../assets/weather/snow.svg';
import Clear from '../../assets/weather/CLEAR.svg';
import APIURLConstants from "../../config/config";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { makeStyles } from '@mui/styles';


const useStyles = makeStyles((theme) => ({
    slantedBox: {
      position: 'relative',
      backgroundColor: '#17408B',
      color: 'white',
      padding: theme.spacing(2),
      paddingBottom: '10px',
      paddingTop: theme.spacing(0.3),
      borderLeft: '55px solid transparent', // Adjust the slant size
      borderBottom: '57px solid #17408B', // Adjust the slant size and color
      clipPath: 'polygon(31% 0%, 0% 100%, 100% 100%, 100% 0%)',
      boxSizing: 'border-box',
      height:'100%'
    },
    weatherIcon: {
        marginLeft:'5px',
        padding:0,
        height: 30,
        backgroundColor: "#17408B",
      },
  }));

const Weather = () => {

    const [todayWeather, setTodayWeather] = useState({ name: "", country: "", temp: "", icon: "03d", weather: "", weatherDesc: "", feelsLike: "", humidity: "", wind: "", highest: "", lowest: "" });
    const [todayWeatherState, setTodayWeatherState] = useState({ name: "", country: "", state: ""});
    const [stateName, setStateName] = useState("");
    // const [searchedLocation, setSearchedLocation] = useState("Vilnius");
    const [lat, setLat] = useState("");
    const [lon, setLon] = useState("");
    const [country, setCountry] = useState("");
    const classes = useStyles();
    const eventInfo = Helper.getStorage('eventInfo');
    const [snackBarProps, setSnackBarProps] = useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });

    useEffect(() => {
            ApiHelper.get(APIURLConstants.GET_WEATHER_INFO(eventInfo.venue)).then(async (res) => {
                if (res) {
                    if (res.data) {
                        if (res.data.cod == '404') {
                            setSnackBarProps({
                                ...snackBarProps,
                                openSnack: true,
                                variant: 'error',
                                message: 'Please enter valid event location',
                            });
                        }
                        else {
                            const data = res.data;
                            const newTemp = Math.ceil(data?.main?.temp);
                            setTodayWeather({ ...todayWeather, name: data.name, country: data.sys.country, temp: newTemp, icon: data.weather[0].icon, weather: data.weather[0].main.toLowerCase(), weatherDesc: data.weather[0].description, feelsLike: data.main.feels_like, humidity: data.main.humidity, wind: data.wind.speed, highest: data.main.temp_max, lowest: data.main.temp_min, });
                        }
                    }
                }
            });
            // ApiHelper.get(APIURLConstants.GET_WEATHER_STATE_INFO(eventInfo.venue)).then(async (res) => {
            //     if (res) {
            //         console.log("data => ", res);
            //         if (res.data) {
            //             if (res.data.cod == '404') {
                            
            //             }
            //             else {
            //                 const data = res.data;
            //                 console.log("firdos => ", data);
            //                 ApiHelper.get(APIURLConstants.GET_STATE_INFO(data[0].state)).then(async (response) => {
            //                     if (response) {
            //                         console.log("response => ", response); 
            //                         setStateName(response.data && response.data.state);
            //                     }
            //                 })
            //                 // const newTemp = Math.ceil(data?.main?.temp);
            //                 setTodayWeatherState({ ...todayWeatherState, name: data.name, country: data.country, state: data.state});
            //             }
            //         }
            //     }
            // });
    }, []);


    return (
        <>
        <Box className={classes.slantedBox}>
            <Box component={'span'} sx={{ fontWeight: 500,position:'relative',top:'30px'}}>
               
                <Box component={'span'} sx={{ display:'flex',justifyContent:'right',fontSize:'25px'}}>
                {todayWeather.temp}&deg;<span style={{ fontSize: '14px', fontWeight: 700 }}>F</span>
                    {(() => {
                        if (todayWeather.weather === '' || todayWeather.weather === 'clear') {
                            return (
                                <Box
                                component="img"
                                alt="Clear Sunny"
                                src={ClearSunny}
                                className={classes.weatherIcon}
                                />)
                        } else if (todayWeather.weather === 'rain') {
                            return (<Box
                                component="img"
                                className={classes.weatherIcon}
                                alt="Rain"
                                src={Rain}
                            /> )
                        } else if (todayWeather.weather === 'thunderstorm') {
                            return (<Box
                                component="img"
                                className={classes.weatherIcon}
                                alt="Thunderstorm"
                                src={Thunderstorm}
                            /> )
                        } else if (todayWeather.weather === 'drizzle') {
                            return (<Box
                                component="img"
                                className={classes.weatherIcon}
                                alt="Drizzle"
                                src={Drizzle}
                            />  )
                        } else if (todayWeather.weather === 'mist' || todayWeather.weather === 'fog') {
                            return (<Box
                                component="img"
                                className={classes.weatherIcon}
                                alt="Mist"
                                src={Mist}
                            /> )
                        } else if (todayWeather.weather === 'haze') {
                            return (<Box
                                component="img"
                                className={classes.weatherIcon}
                                alt="Haze"
                                src={Haze}
                            />  )
                        } else if (todayWeather.weather === 'snow') {
                            return (<Box
                                component="img"
                                className={classes.weatherIcon}
                                alt="Snow"
                                src={Snow}
                            /> )
                        } else if (todayWeather.weather === 'smoke') {
                            return (<Box
                                component="img"
                                className={classes.weatherIcon}
                                alt="Smoke"
                                src={Smoke}
                            />  )
                        } else if (todayWeather.weather === 'clouds') {
                            return (<Box
                                component="img"
                                className={classes.weatherIcon}
                                alt="Clouds"
                                src={Clouds}
                            /> )
                        } else {
                            return (<Box
                                component="img"
                                className={classes.weatherIcon}
                                alt="Clear"
                                src={Clear}
                            /> )
                        }
                    })()}
                </Box>
            </Box>
                <Box component={'span'} sx={{ fontWeight: 500,position:'relative',top:'30px'}}>

                    <Box sx={{display:'flex',flexDirection:'row'}}><LocationOnIcon sx={{color:'#0096FF',fontSize:'25px'}} />{eventInfo.venue}</Box>
                </Box>            
    </Box>
            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({ ...snackBarProps, openSnack: false })
                    }></CustomizedSnackbars>
            )}
        </>
    )
}

export default Weather;